import React, { useState } from 'react'
import s from './video-player.module.scss'
import { IconPlayerPlayFilled } from '@tabler/icons-react';
import { VideoViewer } from '@shared/ui/video-viewer/video-viewer';
import getSuitableImageSize from '@utils/lib/getSuitableImageSize';


export const VideoPlayer = ({src, poster, alt, hidden}) => {
	const [scale, setScale] = useState({ width: 0, height: 0 });
	const [isOpen, setIsOpen] = useState(false);
	const [isLoading, setIsLoading] = useState(true);

	if(hidden) return null

	return (
        <div className={s.wrapper}>
            <VideoViewer isOpen={isOpen} setOpen={setIsOpen} url={src} local />
            <div className={s.videoWrapper}>
                {isLoading && (
                    <div className={s.skeleton}>
                        <div className={s.skeletonPulse} />
                    </div>
                )}
                {scale?.width > 0 && scale?.height > 0 ? (
                    <>
                        <div className={s.playButton}>
                            <button className={s.iconWrapper} onClick={() => setIsOpen(true)}>
                                <IconPlayerPlayFilled className={s.icon} />
                            </button>
                        </div>
                        <video
                            src={src}
                            poster={poster || undefined}
                            className={s.mainSlideImage}
                            alt={alt}
                            controls={false}
                            autoPlay={false}
                        />
                    </>
                ) : (
                    <video
                        src={src}
                        poster={poster || undefined}
                        className={s.mainSlideImage}
                        alt={alt}
                        controls={false}
                        autoPlay={false}
                        preload={poster ? 'metadata' : undefined}
                        onLoadedMetadata={(e) => {
                            const scale = getSuitableImageSize(
                                e.target.videoWidth,
                                e.target.videoHeight
                            );
                            setScale({ width: scale.width, height: scale.height });
                            setIsLoading(false);
                        }}
                    />
                )}
            </div>
        </div>

	)
}